import React from "react";

export default function CustomLoading() {
	return (
            <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "15px"
            }}>
                {/* Spinner animado */}
                <div style={{
                    width: "40px",
                    height: "40px",
                    border: "3px solid #e0e0e0",
                    borderTop: "3px solid #424242",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite"
                }} />
                
                {/* Texto de loading */}
                <div style={{
                    color: "#424242",
                    fontSize: "14px",
                    fontWeight: "500"
                }}>
                    Carregando...
                </div>
                
                {/* CSS para animação */}
                <style>{`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}</style>
            </div>
	);
}

